<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" id="myExtraLargeModalLabel">
      <ng-container *ngIf="!!groupName">
        Edit Custom parameters for Terminal group '{{terminalGroupCustomParameter.groupName}}'
      </ng-container>
      <ng-container *ngIf="!groupName">
        Add Custom parameters for Terminal group '{{terminalGroupCustomParameter.groupName}}'
      </ng-container>
    </h4>
    <button type="button" class="close" (click)="close()">×</button>
  </div>
  <div class="modal-body">


    <div *ngIf="!!participantId" class="card-box">
      <form class="form-horizontal" role="form" autocomplete="off">

        <div class="row" *ngIf="raiseWarning">
          <div class="col-md-12 form-horizontal px-3">
            <ngb-alert [dismissible]="false">
              <strong>Warning!</strong> {{warning}}
            </ngb-alert>
          </div>
        </div>

        <div class="row" *ngIf="raiseDanger">
          <div class="col-md-12 form-horizontal px-3">
            <ngb-alert type="danger" [dismissible]="false">
              <strong>Error!</strong> {{danger}}
            </ngb-alert>
          </div>
        </div>

        <div class="form-group row" *ngIf="canAdd">
          <div class="col-2">
            <label for="CustomTags" class="col-form-label">Custom parameter</label>
          </div>
          <div class="col-6">
            <ng-select2 [(ngModel)]="selectedCustomTag" [ngModelOptions]="{standalone: true}"
                        [data]="mapCustomTags"
                        [options]="select2options" placeholder="Custom tags"></ng-select2>
          </div>
          <div class="col-4">
            <button class="btn btn-info waves-effect waves-light" (click)="addCustomTagsFields()" type="button">
              Add Custom Tags<i class="mdi mdi-plus"></i>
            </button>
          </div>

        </div>
        <hr />

        <ng-container *ngIf="customTagsByParticipant && customTagsByParticipant.length > 0">
          <div class="form-group row" *ngFor="let customTagsFields of customTagsByParticipant">

            <div class="col-2">
              <label for="CardSet" class="col-form-label">{{customTagsFields.customTag}}</label>
            </div>
            <div class="col-1">
              <label for="Value" class="col-form-label">Value:</label>
            </div>
            <div class="col-2">
              <input [(ngModel)]="customTagsFields.value" class="form-control" [ngModelOptions]="{standalone: true}" id="{{customTagsFields.customTag}}" placeholder="Default value" maxlength="15">
            </div>
            <div class="col-1">
              <label for="FileId" class="col-form-label">File Id:</label>
            </div>
            <div class="col-2">
              <ng-select2 [(ngModel)]="customTagsFields.fileId" [ngModelOptions]="{standalone: true}" id="{{customTagsFields.fileId}}"
                          [data]="mapTaParamFiles"
                          [options]="select2options" placeholder="File Id"></ng-select2>
            </div>

            <div class="col-2" *ngIf="canAdd">
              <button class="btn btn-outline-warning  waves-effect waves-light mdi mdi-delete"
                      (click)="UpdateCustomParam(customTagsFields.customTag,customTagsFields.value,customTagsFields.fileId)" type="button">
                Update
              </button>
            </div>
            <div class="col-2" *ngIf="canAdd">
              <button class="btn btn-outline-warning  waves-effect waves-light mdi mdi-delete"
                      (click)="determineCustomTagsDeleteDialog(customTagsFields.customTag)" type="button">
                Delete
              </button>
            </div>

          </div>
        </ng-container>
        <div class="form-group row" offset-3 col-9 *ngIf="warning">
          <div class="col-10">
            <p class="text-warning">{{warningMessage}}</p>
          </div>
        </div>

        <div class="form-group row" offset-3 col-9 *ngIf="error">
          <div class="col-10">
            <p class="text-danger">{{errorMessage}}</p>
          </div>
        </div>
        <div class="form-group row offset-3 col-9" *ngIf="!!createResult && createResult.success == false">
          <ng-container *ngIf="!!createResult.message">
            <p class="text-danger">{{createResult.message}}</p>
          </ng-container>
        </div>


      </form>
    </div>
    
  </div>
</div>
